<template>
    <div class="payme-container">
        <div class="box-container">
            <div class="columns">
                <div class="column is-two-thirds">
                    <div class="field-container">
                        <div>
                            <div class="hd-24 bold black" style="margin-bottom: 16px">{{ $t('web.travel-sim-checkout.simproduct-detail') }}</div>
                            <p class="hd-16 bold" style="margin-bottom: 16px">{{ $t('web.travel-sim-checkout.pending.order-success-please-pay') }}</p>
                            <div class="information-column">
                                <div class="gray500">{{ $t('web.travel-sim-checkout.pending.order-number') }}: </div>
                                <div class="bold">{{ orderNumber }}</div>
                            </div>
                            <div class="information-column">
                                <div class="gray500">{{ $t('web.travel-sim-checkout.user-email') }}: </div>
                                <div class="bold">{{ email }}</div>
                            </div>
                            <div class="information-column">
                                <div class="gray500">{{ $t('web.travel-sim-checkout.pending.need-to-pay') }}: </div>
                                <div class="bold">HK$ {{ amount }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box-container">
            <div class="" v-if="payCodeExpired">
                <div class="hyper7 bold has-text-danger" style="margin-bottom: 8px">{{ $t('web.travel-sim-checkout.pending.paycode-expired') }}</div>
            </div>
            <div class="" v-if="payCodeError">
                <div class="hyper7 bold has-text-danger" style="margin-bottom: 8px">{{ $t('web.travel-sim-checkout.pending.paycode-error') }}</div>
            </div>
            <div v-if="!(payCodeExpired || payCodeError) && isMobile">
                <p class="bold hd-16" style="margin-bottom: 8px; text-align: center">{{ $t('web.travel-sim-checkout.pending.mobile-redirection-text') }}</p>
                <button @click.prevent="mobileRedirect" class="button payme-button is-rounded">
                    <img src="/images/payme-button-logo.svg" />
                </button>
            </div>
            <div class="columns" v-if="!(payCodeExpired || payCodeError) && !isMobile">
                <div class="column is-narrow">
                    <div class="hyper7 bold" style="margin-bottom: 8px">{{ $t('web.travel-sim-checkout.payment.payme-title') }}</div>
                    <payme-qr-code :url="qrLink"></payme-qr-code>
                </div>
                <div class="column">
                    <div class="hyper6 bold" style="margin-bottom: 8px">{{ $t('web.travel-sim-checkout.payment.payme-instruction-title') }}</div>
                    <p>{{ $t('web.travel-sim-checkout.payment.payme-instruction-step-1') }}</p>
                    <p>{{ $t('web.travel-sim-checkout.payment.payme-instruction-step-2') }}</p>
                    <p>{{ $t('web.travel-sim-checkout.payment.payme-instruction-step-3') }}</p>
                    <div style="border: 1px solid rgb(241, 242, 243); margin: 20px 0 6px;"></div>
                    <small style="color: #B7BDC1">{{ $t('web.travel-sim-checkout.payment.payme-instruction-do-not-close') }}</small>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { isAndroid, isIOS } from 'mobile-device-detect';
    export default {
        components: {},

        props: {
            qrLink: String,
            apiDomain: String,
            orderNumber: String,
            email: String,
            amount: String,
            appLink: String,
            successCallbackUrl: String,
        },

        data: function () {
            return {
                paymentStatus: null,
                payCodeExpired: false,
                payCodeError: false,
                isMobile: false,
                interval: null
            }
        },

        methods:{
            mobileRedirect(){
                window.location = this.qrLink;
            },
            async checkStatus(){
                try {
                    const res = await axios.get(window.location.protocol + "//" + this.apiDomain + "/api/v1/payme/status/" + this.orderNumber);
                    this.payCodeError = false;
                    this.payCodeExpired = false;
                    if(res && res.data && res.data.success){
                        this.paymentStatus = res.data.status;
                        switch (this.paymentStatus) {
                            case "success":
                                clearInterval(this.interval);
                                window.location = this.successCallbackUrl;
                                break;
                            case "expired":
                                this.payCodeExpired = true;
                                clearInterval(interval);
                                break;
                            case "failed":
                                clearInterval(interval);
                                this.payCodeError = true;
                                break;
                        }
                    }
                }catch (e) {
                    this.payCodeError = false;
                    this.payCodeExpired = false;
                    if(e.response && e.response.data && e.response.data.message){
                        this.payCodeError = true;
                    }
                }
            }
        },

        mounted() {
            if(isAndroid || isIOS){
                this.isMobile = true;
            }
            this.checkStatus();
            this.interval = setInterval(() => {
                this.checkStatus();
            }, 10 * 1000);
        }
    }
</script>
<style lang="scss" scoped>
    .payme-container{
        margin-bottom: 16px;

        .box-container{
            background-color: #FFF;
            padding: 16px;
            margin-bottom: 16px;
        }

        .information-column{
            margin-bottom: 16px;
        }

        .payme-button{
            background: #DB0011;
            border-color: #DB0011;
            padding: 5px 80px;
            height: auto;

            &:focus{
                border-color: #DB0011;
            }

            img{
                height: 30px;
            }

            &.is-loading img{
                opacity: 0;
            }
        }
    }
</style>